<template>
    <div class="centerPage">
        <div class="pageTit">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/admin/dict/list'}">字典管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/admin/dict/edit?id='+editData.catalogId}">字典编辑</el-breadcrumb-item>
                <el-breadcrumb-item>二级编辑</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-collapse :value="editId?'2':'1'" accordion>
            <el-collapse-item title="字典编辑" name="1" >
                <el-form ref="form" class="article_edit">

                    <el-form-item label="字典名称：">
                        <el-input v-model="editData.itemName" style="width: 1000px" placeholder="请输入字典名称">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="字典代码：">
                        <el-input v-model="editData.itemCode" style="width: 1000px" placeholder="请输入字典代码">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="类型：">
                        <el-radio-group v-model="editData.itemType" class="type">
                            <el-radio :label="1">可编辑</el-radio>
                            <el-radio :label="0">不可编辑</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="状态：">
                        <el-radio-group v-model="editData.status" class="type">
                            <el-radio :label="1">启用</el-radio>
                            <el-radio :label="0">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="字典描述：">
                        <el-input v-model="editData.itemDesc" style="width: 1000px" placeholder="请输入字典描述" :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="editData.remark" style="width: 1000px" placeholder="请输入备注" :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
                        </el-input>
                    </el-form-item>
                    <div class="btn">
                        <el-button @click="toUpdate" v-if="editId">更新</el-button>
                        <el-button @click="toSave" v-else>添加</el-button>
                    </div>
                </el-form>
            </el-collapse-item>
            <el-collapse-item title="三级字典表" name="2" v-if="editId">
                <el-button @click="toEdit(0)">
                    添加
                </el-button>
                <template>
                    <el-table
                            :data="listData.filter(data => !search || data.itemName.toLowerCase().includes(search.toLowerCase()))"
                            stripe
                            style="width: 100%">
                        <el-table-column
                                prop="id"
                                label="id"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="subName"
                                label="字典名称"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="subCode"
                                label="字典代码"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="subType"
                                label="类型">
                            <template slot-scope="scope">
                                <span v-if="scope.row.dictType === 0" style="color: orangered">可编辑</span>
                                <span v-else-if="scope.row.dictType === 1" style="color: #56C147">不可编辑</span>
                                <span v-else>无数据</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status === 0" style="color: orangered">封禁</span>
                                <span v-else-if="scope.row.status === 1" style="color: #56C147">正常</span>
                                <span v-else>无数据</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="subDesc"
                                label="字典描述">
                        </el-table-column>
                        <el-table-column
                                prop="remark"
                                label="备注">
                        </el-table-column>
                        <el-table-column
                                align="right"
                                width="250">
                            <template slot="header" slot-scope="scope">
                                <el-input
                                        v-model="search"
                                        :data-solveBug="scope"
                                        size="mini"
                                        placeholder="输入关键字搜索"/>
                            </template>
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger" @click="toDelete(scope.row.id)">删除</el-button>
                                <el-button @click="toEdit(scope.row.id)" size="mini" type="info">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
    import commonjs from "../../../api/common";
    export default {
        name: "itemEdit",
        data() {
            return {
                editData: {
                    itemCode: "",
                    itemDesc: "",
                    itemName: "",
                    itemType: "",
                    id: "",
                    remark: "",
                    haveSubItem: "",
                    catalogId: this.$route.query.catalogId,
                },
                editId: this.$route.query.id,

                listData: [],
                search: '',
            }
        },
        mounted() {
            if (this.editId != null) {
                this.getEditData();
                this.getListData();
            }
        },
        methods: {
            getEditData() {
                let that = this;
                this.$ajax
                    .get(commonjs.api.dict.edit.item.detail.replace("{id}",this.editId))
                    .then(function (res) {
                        if (res.data.status === 'success') {
                            that.editData = res.data.data;
                        } else {
                            that.$message.error(res.data.message);
                            that.toPush();
                        }
                    })
            },
            toSave() {
                let that = this;
                this.$ajax
                    .post(commonjs.api.dict.edit.item.save,this.editData)
                    .then(function (res) {
                      if (res.data.status === 'success') {
                        that.$message.success('操作成功');
                        that.toPush();
                      } else {
                        that.$message.error(res.data.message);
                      }
                    }).catch((err) => {
                  console.error(err);
                  that.$message.error('操作失败');
                })
            },
            toUpdate() {
                let that = this;
                this.$ajax
                    .post(commonjs.api.dict.edit.item.update,this.editData)
                    .then(function (res) {
                      if (res.data.status === 'success') {
                        that.$message.success('操作成功');
                        that.toPush();
                      } else {
                        that.$message.error(res.data.message);
                      }
                    }).catch((err) => {
                  console.error(err);
                  that.$message.error('操作失败');
                })
            },
            getListData() {
                let that = this;
                this.$ajax
                    .get(commonjs.api.dict.edit.sub.list.replace("{itemId}",this.editId))
                    .then(function (res) {
                        if (res.data.status === 'success') {
                            that.listData = res.data.list;
                        }
                    })
            },
            toDelete(id) {
                let that = this;
                this.$confirm('如果只是想暂时下架字典三级表字段,可禁用', '确认删除?', {
                    confirmButtonText: '删除',
                    cancelButtonText: '不删了',
                    type: 'warning'
                }).then(() => {
                    this.$ajax
                        .delete(commonjs.api.dict.edit.sub.delete.replace("{id}",id))
                        .then(function (res) {
                          if (res.data.status === 'success') {
                            that.$message.success('操作成功');
                            that.getListData();
                          } else {
                            that.$message.error(res.data.message);
                          }
                        }).catch((err) => {
                      console.error(err);
                      that.$message.error('操作失败');
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            toEdit(id) {
                if (id===0) {
                    this.$router.push({name: 'dictSubEdit',query: {catalogId: this.editData.catalogId,itemId: this.editId}})
                } else {
                    this.$router.push({name: 'dictSubEdit',query: {catalogId: this.editData.catalogId,itemId: this.editId,id: id}})
                }
            },
            toPush() {
                this.$router.push({name: 'catalogEdit',query: {id: this.editData.catalogId}});
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../assets/css/banner.scss';

    .centerPage {
        display: block;
    }
</style>